import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const InchargeManPower = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        extra_manpower: "",
        reason:"",
    })


     const [toggle,setToggle]=useState(false);
	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }

    const [department, setDepartmentValue] = useState("");
    const [currentmanpower, setCurrentManPowerValue] = useState("");



  const handleDropdownChange = (event) => {
    
    const value = event.target.value;
    setDepartmentValue(value);
   

    axios.get(API_BASE_URL +'/count_department/'+value, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response => {
    //     console.log(response.data[0].week_count); // Assuming response has a "text" field
    // })

    .then(response => {
        setCurrentManPowerValue(response.data[0].week_count); // Assuming response has a "text" field
    })
    .catch(error => console.error("Error fetching text:", error));

    // Update textbox value based on dropdown selection
   
  };


	


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const filteredItems = records.filter((item) => {
  const search = searchTerm.toLowerCase();

  return (
    String(item.department_name ?? "").toLowerCase().includes(search) ||
    String(item.current_manpower ?? "").includes(search) ||
    String(item.extra_manpower ?? "").includes(search) ||
    String(item.incharge_reason ?? "").toLowerCase().includes(search) ||
    String(item.date ?? "").includes(search)
  );
});

		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

		const startIndex = (currentPage - 1) * entriesPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };

	  const clearInput = () => {
		setSearchTerm("");
	  };
	
	 

  useEffect(()=> {
	axios.get(API_BASE_URL +'/showallemployee', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setData(res.data.user_det))
	.catch(err => console.log(err));
},[])



useEffect(()=> {
	axios.get(API_BASE_URL +'/incharge_manpower_request', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setRecords(res.data.manpower))
	.catch(err => console.log(err));
},[])












const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;      // prevent double submit
    setSubmitting(true);

	// alert(department);
	// alert(currentmanpower);
	// alert(user.extra_manpower);
	// alert(user.reason);
	// setLoading(true);
 

axios.post(API_BASE_URL+'/incharge_request_manpower', { department: department, current_manpower: currentmanpower,extra_manpower:user.extra_manpower,incharge_reason:user.reason }, {
	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// 	console.log(response.data);
// 	console.log(response.data.message);
// })

var status = response.data.status;

if (status == 200) {
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});


const timeout = setTimeout(() => {
window.location.reload(); // Reload the current page
}, 5000); // Refresh after 5 seconds

return () => {
clearTimeout(timeout); // Cleanup the timeout if the component unmounts
};

} else if(status == 401) {
setSubmitting(false);
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});
}
else if (status == 400) {
setSubmitting(false);
toast.error(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",

});
}


}).catch(error => {
setSubmitting(false);
// console.log(error);
// console.log(error.response.data.message);




toast.error(error.response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",


});

});


  };



  // const paginate= (page) => setCurrentPage(page);

	


	useEffect(()=> {
		axios.get(API_BASE_URL +'/all_departments_of_incharge', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
	
		//.then(res =>console.log(res.data))
		 .then(res => setdataval(res.data))
		.catch(err => console.log(err));
	},[])


	const columns = [
  { label: "Department Name", key: "department_name", sortable: true },
  { label: "Current Manpower", key: "current_manpower", sortable: true },
  { label: "Manpower Requested", key: "extra_manpower", sortable: true },
  { label: "Reason", key: "incharge_reason", sortable: true },
  { label: "Date", key: "date", sortable: true },
];

	
	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>


                    

					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
                                                <button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={()=>setToggle(!toggle)}
                                                        >
                                                            <i className="fe fe-plus mr-2" />
                                                            Add
                                                        </button>
                                                        {toggle && (
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">

                                                      


                                                       


															 <form onSubmit={handleSubmit} > 
					
																<div class="row">
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group required-tooltip">
                                                                    <label className="form-label">Department</label>
																	<select className="form-control show-tick required-input" name="department" value={department} onChange={handleDropdownChange}>
                                                                    <option value="">Select Department</option>
                                                                        {dataval.map((option) => (
                                                                            <option key={option.department_id} value={option.department_id}>
                                                                            {option.department_name} 
                                                                            </option>
                                                                        ))}
																    </select>
																	</div>
																</div>
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group">
                                                                    <label className="form-label">Current Manpower</label>
																	<input type="text" className="form-control" name="currentmanpower" value={currentmanpower}
													readOnly />
																	
																
																	</div>
																</div> 
					
															
					
													</div>

													<div class="row">

													<div className="col-md-4 col-sm-12">
															<div className="form-group required-tooltip">
															
                                                            <label className="form-label">Extra Manpower</label>

															<input type="text" className="form-control required-input" name="extra_manpower" value={user.extra_manpower}
								onChange={handelInput}/>
																
															</div>
														</div>



                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="form-group required-tooltip">
                                                            <label className="form-label">Reason</label>

                                                            <textarea
                                                            id="textarea"
                                                            className="form-control required-input"
                                                            name="reason"
                                                            value={user.reason} // Bind the value to state
                                                            onChange={handelInput} // Update state on change
                                                            placeholder="Reason"
                                                            rows="2" // Number of rows (optional)
                                                        ></textarea>
                                                        
                                                        </div>
                                                    </div>
					
														
														
												
					
													
													
					
					
													<div className="col-md-4 col-sm-6">
														<div className="form-group">
					
													<button type="submit" className="btn btn-primary" disabled={submitting}>
													{submitting ? "Submitting..." : "Submit"}
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>

                                               
														</div>
													</div>
                                                     )}
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
																	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
																		<path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
																	</svg>
																	Man Power Request
																</h3>
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive sticky-table-wrap">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
																		<thead>
																			<tr>
																				
																				 {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																				
																			</tr>
																		</thead>
																		<tbody>
																		{filteredData.length > 0 ? (
																				filteredData.map((record, index) => (
																					<tr key={`${record.department_name}-${record.date}-${index}`}>
																						<td>{record.department_name}</td>
																						<td>{record.current_manpower}</td>
																						<td>{record.extra_manpower}</td>
																						<td>{record.incharge_reason}</td>
																						<td>{record.date}</td>
																					</tr>
																					))
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



		




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(InchargeManPower);